import { Suspense, useState, useRef, useContext, useEffect } from "react";
import { useNavigate, useLocation, NavLink, Link } from "react-router-dom";
import Logo from "../../assets/img/svg/logo-navbar.svg";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modulos from "../../assets/img/svg/modulos.svg";
import Persona from "../../assets/img/svg/persona.svg";
import UserConnected from "./userConnected";
import Proveedores from "../../assets/img/svg/proveedores.svg";
import Proyectos from "../../assets/img/svg/proyectos.svg";
import Soporte from "../../assets/img/svg/soporte.svg";
import Seguridad from "../../assets/img/svg/seguridad.svg";
import Usuarios from "../../assets/img/svg/usuario.svg";
import Swal from "sweetalert2";
import { UserContext } from "../../context/userContext/UserContext";
import NotificationsDropdown from "./notificationsMenu";
import { IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import NotificationsModal from "../notifications/NotificationsModal";

function NavBar({ API_URL, companies }) {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const iconRef = useRef(null);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Refs para calcular el espacio entre logo y toggle (JS puro)
  const barRef = useRef(null);
  const brandRef = useRef(null);
  const togglerRef = useRef(null);

  const [open, setOpen] = useState(false);

  function Loading() {
    return <h2>🌀 Cargando...</h2>;
  }

  const toggleMenu = () => {
    if (iconRef.current) {
      const { top, left, height } = iconRef.current.getBoundingClientRect();
      setMenuPosition({
        top: top + height + window.scrollY + 10,
        left: left - 35,
      });
    }
    setMenuVisible(!isMenuVisible);
  };

  const handleLogout = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/logout`, {
        withCredentials: true,
      });

      if (response.status === 200) {
        setMenuVisible(false);
        Swal.fire({
          position: "bottom-end",
          icon: "success",
          title: "Sesión cerrada con éxito",
          showConfirmButton: false,
          timer: 1500,
        }).then(
          setTimeout(() => {
            navigate("/");
          }, 1500)
        );
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  // Calcular límites izquierdo/derecho del collapse en móvil
  useEffect(() => {
    const updateBounds = () => {
      const bar = barRef.current;
      const brand = brandRef.current;
      const toggler = togglerRef.current;
      if (!bar || !brand || !toggler) return;

      const barRect = bar.getBoundingClientRect();
      const brandRect = brand.getBoundingClientRect();
      const togglerRect = toggler.getBoundingClientRect();

      // margen de 8px
      const left = Math.max(0, Math.round(brandRect.right - barRect.left + 8));
      const right = Math.max(
        0,
        Math.round(barRect.right - togglerRect.left + 8)
      );

      bar.style.setProperty("--collapse-left", `${left}px`);
      bar.style.setProperty("--collapse-right", `${right}px`);
      // si tienes franja superior adicional, cambia este valor
      bar.style.setProperty("--drawer-top-extra", "0px");
    };

    updateBounds();
    window.addEventListener("resize", updateBounds);
    const t1 = setTimeout(updateBounds, 100);
    const t2 = setTimeout(updateBounds, 400);

    return () => {
      window.removeEventListener("resize", updateBounds);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <Navbar style={{ padding: 0 }} expand="lg">
      <NotificationsModal
        API_URL={API_URL}
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={() => {}}
        companies={companies}
      />
      <Container fluid className="flex-column">
        <div className="navBarLine flex">
          <Row style={{ padding: 0, "--bs-gutter-x": 0 }}>
            <Col lg={10}></Col>
            <Col lg={2} style={{ padding: 0, "--bs-gutter-x": 0 }}>
              <div className="d-flex justify-content-around iconsNavBarLine">
                <NotificationsDropdown API_URL={API_URL} />
                <IconButton
                  title="Notificación a Proveedores"
                  size="small"
                  sx={{
                    p: 0,
                    display: user?.perfil?.esAdministrador ? "block" : "none",
                  }}
                  onClick={() => setOpen(true)}
                >
                  <SendIcon viewBox="0 0 26 26" htmlColor="#62C776" />
                </IconButton>
                <Link title="Inicio" to="/check">
                  <img id="icon-home" src={Modulos} alt="" />
                </Link>
                <img
                  ref={iconRef}
                  onClick={toggleMenu}
                  src={Persona}
                  alt=""
                  style={{ cursor: "pointer" }}
                  title="Usuario"
                />
                {isMenuVisible && (
                  <UserConnected
                    menuPosition={menuPosition}
                    handleLogout={handleLogout}
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>

        {/* Contenedor de logo + toggle + collapse */}
        <div className="navBar" ref={barRef}>
          <Navbar.Brand>
            <Suspense className="w-25" fallback={<Loading />}>
              {/* En JS, por si Link no te acepta ref en tu versión, lo envolvemos */}
              <div ref={brandRef}>
                <Link to={"/check"}>
                  <img src={Logo} alt="Logo" />
                </Link>
              </div>
            </Suspense>
          </Navbar.Brand>

          {/* Toggle a la derecha */}
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="ms-auto"
            ref={togglerRef}
          />

          {/* Collapse que se posiciona ENTRE logo y toggle en móvil */}
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="bg-white mobile-drawer-between"
          >
            <div className="d-flex flex-column w-100 navBarText">
              <Nav className="me-auto navBarModules">
                {user?.perfil?.esAdministrador && (
                  <Nav.Link
                    as={NavLink}
                    to="/usuarios"
                    className={`navBar-link ${
                      location.pathname.startsWith("/usuarios/") ||
                      location.pathname === "/usuarios"
                        ? "active-route"
                        : ""
                    }`}
                  >
                    <img src={Usuarios} alt="" /> Usuarios
                  </Nav.Link>
                )}

                <Nav.Link
                  as={NavLink}
                  to="/proveedores"
                  className={`navBar-link ${
                    location.pathname.startsWith("/proveedores/") ||
                    location.pathname === "/proveedores"
                      ? "active-route"
                      : ""
                  }`}
                >
                  <img src={Proveedores} alt="" /> Proveedores
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  to="/proyectos"
                  className={`navBar-link ${
                    location.pathname.startsWith("/proyectos/") ||
                    location.pathname === "/proyectos"
                      ? "active-route"
                      : ""
                  }`}
                >
                  <img src={Proyectos} alt="" /> Proyectos
                </Nav.Link>
                {user?.perfil?.esAdministrador && (
                  <NavDropdown
                    align="end"
                    title={
                      <span>
                        <img src={Seguridad} alt="Seguridad" />
                        Inspecciones
                      </span>
                    }
                    id="basic-nav-dropdown-ins"
                  >
                    <NavDropdown.Item href="#action/3.1">
                      Crear inspección
                    </NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.2">
                      Crear supervisión
                    </NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.3">
                      Crear incidencia
                    </NavDropdown.Item>
                  </NavDropdown>
                )}
                {user?.perfil?.esAdministrador && (
                  <Nav.Link
                    as={NavLink}
                    to="/soporte"
                    className={`navBar-link ${
                      location.pathname.startsWith("/soporte/") ||
                      location.pathname === "/soporte"
                        ? "active-route"
                        : ""
                    }`}
                  >
                    <img src={Soporte} alt="" /> Soporte Operativo
                  </Nav.Link>
                )}
              </Nav>
            </div>
          </Navbar.Collapse>
        </div>
      </Container>
    </Navbar>
  );
}

export default NavBar;
